<div *ngIf="errors && errors.length > 0" class="alert alert-danger text-start mb-0">
	<div class="row justify-content-between align-items-center g-0">
		<div class="col-24 col-lg">
			<h3 class="d-flex justify-content-between align-items-center mb-2">
				<span>Validation Error</span>
				<fa-icon class="fs-1" [icon]="iconError"></fa-icon>
			</h3>

			<div *ngFor="let error of errors">
				{{ error }}
			</div>
		</div>
	</div>
</div>
